module.exports = __webpack_public_path__ + "img/mgh-nihonbashi-premier-sp@2x.5a06fe0e.jpg";